import styled from '@emotion/styled';
import { bodyB } from '@teamsparta/stack-font';

import { device } from '@/styles/themes';

export const ToastFrame = styled.div`
  position: fixed;
  top: 24px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 190;
  @media screen and ${device.desktop} {
    top: 100px;
  }
`;

export const Toast = styled.div<{ show: boolean }>`
  width: fit-content;

  visibility: ${(props) => (props.show ? 'visible' : 'hidden')};
  color: #ffffff !important;
  padding: 10px 24px 10px 18px;
  animation-fill-mode: forwards;

  ${bodyB};
  border-radius: 100px;
  background: rgba(69, 69, 69, 0.7);
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  gap: 8px;

  @media ${device.desktop} {
  }
`;
